import React from "react";
import {Tooltip } from '@mui/material';
import i18n from '../../i18n/i18n';

/**
 * Composant permettant d'ajouter une tooltip sur un composant enfant et permet de copier un texte dans le presse-papier
 *
 * @param text texte à afficher sur la tooltip (par défaut texte copié)
 * @param children le composant sur lequel on affiche la tooltip
 * @param duration la durée d'affichage en ms (par défaut 500ms)
 * @param copyValue la valeur à copier
 * @returns {Element}
 * @constructor
 */
const TooltipOnClick = ({ text = i18n.t("copied"), children, duration = 500, copyValue = null }) => {
  const [open, setOpen] = React.useState(false);

  const handleTooltipOpenAndCopyValue = () => {
    copyValue && navigator.clipboard.writeText(copyValue)
    setOpen(true);
    setTimeout(() => {setOpen(false)}, duration)
  };

  return (
    <Tooltip
      open={open}
      arrow
      title={text}
      placement="top"
    >
      <div onClick={handleTooltipOpenAndCopyValue}>
        {children}
      </div>
    </Tooltip>
  )
}
export default TooltipOnClick;